import $ from "jquery";
import "./fullpage_init";
import getParam from "../util/getParam";

$(document).on("turbolinks:load", () => {
  // Opens contact modal automatically on homepage
  if (getParam("contact_us")) {
    const $contactButton = $("a[data-bs-target='#contactModal']");
    if ($contactButton.length) {
      $contactButton.trigger("click");
    } else {
      const $contactModal = $("#contactModal");
      $contactModal.addClass("show").css("display", "block");
      $contactModal.find("button[data-bs-dismiss='modal'], input[type=submit]").on("click", (e) => {
        if (e.target.tagName == "INPUT") {
          const $inputs = $contactModal.find("form input:not([type=hidden])");
          for (var i = 0; i < $inputs.length; i++) {
            if (!$($inputs[i]).val().length) {
              return;
            }
          }
        }
        $contactModal.removeClass("show").css("display", "none");
      });
    }
  }
});
